import {Translatable} from 'common/i18n';

import {TEXT_HIGHLIGHT_THEME} from '../text-highlight';
import {SvgIconProps} from '../svg-icon';

export interface TooltipSection {
  bulletStyle?: TooltipBulletStyle;
  bulletColor?: string;
  icon?: SvgIconProps;
  rows?: TooltipRow[];
}

export interface TooltipRow {
  items: TooltipItem[];
}

export interface TooltipItem {
  text: Translatable;
  type: TooltipItemType;
  // Intended for TooltipItemType=Data theme for text highlight
  theme?: TEXT_HIGHLIGHT_THEME;
}

export enum TooltipItemType {
  Data = `data`,
  Strong = `strong`,
  Text = `text`,
  Detail = `detail`,
  Segment = `segment`,
  Separator = `separator`,
  MetricName = `metric-name`,
  WeightedDetail = `weighted-detail`,
}

export enum TooltipBulletStyle {
  Dash = `dash`,
  Solid = `solid`,
}
